import { Fragment } from "react";

import MainNavigation from "./MainNavigation";
import Background from "./Background/Background";
import Footer from "./Footer";
import { useLocation } from "react-router-dom";

const Layout = (props) => {
  const location = useLocation();

  const hideFooter = location.pathname === "/ideamap";

  return (
    <Fragment>
      <Background />
      <MainNavigation title={props.title} username={"John"} user={props.user}/>
      <main>{props.children}</main>
      {!hideFooter && <Footer />}
    </Fragment>
  );
};

export default Layout;
